var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useInnerValue } from 'ziphy-web-shared/basic/hooks';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Input } from 'ziphy-web-shared/basic/lib/forms/fields';
import { ProgressRing } from 'ziphy-web-shared/basic/lib/loaders';
import { ConnectedGroup } from 'ziphy-web-shared/basic/lib/simple';
import styles from './DropdownInput.module.scss';
const DropdownInput = forwardRef((_a, ref) => {
    var { field, onKeyDown, placeholder, mode = ['xs'], innerClassName, 
    //
    submitMode = 'update-on-submit', buttonMode = ['primary-outline', 'xs', 'minAuto'] } = _a, 
    //
    inputProps = __rest(_a, ["field", "onKeyDown", "placeholder", "mode", "innerClassName", "submitMode", "buttonMode"]);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [innerValue, setInnerValue] = useInnerValue(field.value);
    const handleSubmit = useCallback((e) => {
        if (innerValue !== field.value) {
            const promise = field.onChange(innerValue);
            if (promise instanceof Promise) {
                if ((e === null || e === void 0 ? void 0 : e.currentTarget) && e.currentTarget instanceof HTMLInputElement) {
                    e.currentTarget.blur();
                }
                setIsLoading(true);
                promise.finally(() => {
                    setIsLoading(false);
                    setInnerValue('');
                });
            }
            else {
                setInnerValue('');
            }
        }
    }, [innerValue, field.value]);
    const handleKeydown = useCallback((e) => {
        if ((e === null || e === void 0 ? void 0 : e.key) === 'Enter') {
            e.preventDefault();
            handleSubmit(e);
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        }
    }, [handleSubmit]);
    return (_jsx(ConnectedGroup, { className: classNames(styles.container, { [styles.containerLoading]: isLoading }), renderItems: [
            ({ getClass }) => {
                return (_jsx(Input, Object.assign({ ref: ref, field: {
                        value: innerValue,
                        onChange: submitMode === 'update-on-submit' ? setInnerValue : field.onChange,
                    }, mode: mode, placeholder: placeholder ? placeholder : t('label.other'), innerClassName: classNames(styles.input, innerClassName, getClass()), onKeyDown: submitMode === 'update-on-submit' ? handleKeydown : onKeyDown }, inputProps, { children: isLoading ? (_jsx(ProgressRing, { radius: 12, progress: 25, spin: true, className: styles.loader })) : null })));
            },
            ({ getClass }) => {
                return submitMode === 'update-on-submit' ? (_jsx(Button, Object.assign({ mode: buttonMode, className: classNames(styles.button, getClass()), onClick: () => handleSubmit(), disabled: innerValue === field.value }, { children: t('btn.ok') }))) : null;
            },
        ] }));
});
export default observer(DropdownInput);
